/** Global numeric constants for map dimensions, display resolution, camera, and DPR compensation. */
export const TILE_SIZE = 32;
export const MAP_WIDTH_TILES = 80;
export const MAP_HEIGHT_TILES = 60;
export const MAP_WIDTH_PX = MAP_WIDTH_TILES * TILE_SIZE;
export const MAP_HEIGHT_PX = MAP_HEIGHT_TILES * TILE_SIZE;

export const CAMERA_LERP = 0.1;
export const CAMERA_ZOOM = 1.0;

// Device pixel ratio — used to render the canvas at native physical resolution.
// Falls back to 1 in non-browser environments (Node test harness).
export const DPR = typeof window !== 'undefined' ? (window.devicePixelRatio || 1) : 1;

// Canvas scale — physical canvas pixels per logical coordinate unit (before DPR).
// The canvas is GAME_WIDTH * CANVAS_SCALE * DPR pixels wide, but UI code positions
// everything in GAME_WIDTH × GAME_HEIGHT logical space. Camera zoom = DPR * CANVAS_SCALE
// maps that logical space onto the full canvas.
// At CANVAS_SCALE=1 this reduces to the original DPR-only system.
export const CANVAS_SCALE = 1.6;

export const GAME_WIDTH = 800;
export const GAME_HEIGHT = 500;

// Combined UI zoom factor applied to all non-GameScene cameras.
// Canvas = 1280×800 at DPR=1 (2560×1600 at DPR=2), viewed through
// GAME_WIDTH×GAME_HEIGHT = 800×500 logical coordinates.
const TOTAL_UI_ZOOM = DPR * CANVAS_SCALE;

// Scroll offsets that compensate for Phaser's camera origin scaling with canvas size.
// Phaser calculates originX = canvas_width * 0.5, so on a 1280-wide canvas (DPR=1),
// originX=640. With zoom=1.6, the visible width is 800 — the worldView starts at
// x=240 instead of x=0. These offsets bring the viewport back to (0,0).
// GameScene uses startFollow which overrides scroll automatically.
export const DPR_SCROLL_X = -GAME_WIDTH * (TOTAL_UI_ZOOM - 1) / 2;
export const DPR_SCROLL_Y = -GAME_HEIGHT * (TOTAL_UI_ZOOM - 1) / 2;

// Position offset for scrollFactor(0) objects in zoomed cameras.
// Phaser's camera transform (translate→scale→translate) shifts the rendering
// origin for scroll-fixed elements. Add these to logical screen coordinates
// to get the correct world position for scrollFactor(0) placement.
export const SF0_X = -DPR_SCROLL_X;
export const SF0_Y = -DPR_SCROLL_Y;

// Half-diagonal of the viewport — the max distance from screen center to corner.
// Used as the base for enemy detection radius (1.0 = screen edge).
export const DETECTION_RANGE = Math.sqrt(GAME_WIDTH * GAME_WIDTH + GAME_HEIGHT * GAME_HEIGHT) / 2;

// Current zone identifier — single-zone for now; will become dynamic with multi-zone support.
export const CURRENT_ZONE = 'zone-1';
